import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseWarning } from "../../../secondary";
import styles from "../characteristicCustomForm.module.scss";
import { Button, Form } from "../../../primary";
import { useForm } from "react-hook-form";
import { CharacteristicCustomFormSingleSelect } from "../characteristicCustomFormSingleSelect";
import { CharacteristicCustomFormMultiSelect } from "../characteristicCustomFormMultiSelect";
import { CharacteristicCustomFormText } from "../characteristicCustomFormText";
import { signedLockedAccess } from "../../../../utils";
import { CANCEL_BTN, CANCEL_ID, SAVE_BTN, SUBMIT_ID } from "../../../../constants";
import { setStatusUpdateForm, updateViewFormAsyn } from "../../../../app/customFormSlice";
import constants from "../../../../constants/constants.json";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import infoIcon from "../../../../static/images/info.svg";

const sortByOrder = (a, b) => (a.order ?? 0) - (b.order ?? 0);

export const EditCustomForm = ({
  index,
  name,
  formId,
  queryParam,
  updateDone,
  selectedIndex,
  hideIt,
  assessmentDetails,
  isCompleted,
  customFormBuilder,
  getForm,
  setgetForm,
  closeWarning,
  handleYes,
  handleNo,
  characteristicTabsData,
  setFormChangesConfirm,
  setClickCancel,
  setcustomFormBuilder,
}) => {
  const { register, handleSubmit, errors, reset, setValue, clearErrors } = useForm({
    mode: "onBlur",
  });

  const dispatch = useDispatch();

  // const [editformBranch, seteditformBranch] = useState(false);

  const showViewForm = useSelector((state) => state.forms.viewForms);
  const getUserRole = useSelector((state) => state.user);
  const forms = useSelector((state) => state.forms.formDetailsData);
  const [sectionError, setSectionError] = useState([]);

  useEffect(() => {
    dispatch(setStatusUpdateForm({}));
    reset({});
    formBuilder && setcustomFormBuilder(formBuilder);
    // if (showViewForm?.formdata?.length === 0) {
    //   formBuilder && questionLevelBranch(formBuilder);
    // }
  }, [forms]);

  let formBuilder = forms.formBuilderInfo && [...forms.formBuilderInfo];
  forms.formBuilderInfo &&
    formBuilder.sort((a, b) => {
      return a.order - b.order;
    });

  const payload = {
    id: formId,
    queryParam: queryParam,
  };

  const formQuestions = useMemo(() => forms?.formBuilderInfo ?? [], [forms?.formBuilderInfo]);
  const sectionInfo = useMemo(() => forms?.sectionInfo ?? [], [forms?.sectionInfo]);

  const questionMap = useMemo(() => new Map(formQuestions.map((q) => [q.id, q])), [formQuestions]);

  const sections = useMemo(() => sectionInfo.map((section) => ({
    name: section.name,
    isMandatory: section.isMandatory,
    questions: section.questionsId
      .map((id) => questionMap.get(id))
      .filter(Boolean)
      .sort(sortByOrder),
  })), [questionMap, sectionInfo]);

  const sectionQuestionIds = new Set(sectionInfo.flatMap((section) => section.questionsId));

  const unSectioned = formQuestions.filter((q) => !sectionQuestionIds.has(q.id)).sort(sortByOrder);

  const SelectedVal = (dataform) => {
    setgetForm(dataform);
  };

  const questionLevelBranch = (formBuilder) => {
    let branchNumber = "";
    let branch = [];
    formBuilder.forEach((value, index) => {
      if (branchNumber === "" || branchNumber === index || branchNumber === "next") {
        branchNumber = checkBranch(value, index);

        if (value.type !== "text" && Array.isArray(value.options)) {
          value.options.forEach((option) => {
            if (branchNumber === "" && option.goto !== null && option.goto !== undefined) {
              branchNumber = index;
            }
          });
        }

        branch.push(value);
      }
    });

    setcustomFormBuilder(branch);
  };

  const optionLevelbranching = (selectedVal, pIndex, id, customFormBuild, branchOptionNum) => {
    let branchNumber = "";
    const branchFormBuilder = [...formBuilder];
    const selectedIndex = branchFormBuilder.findIndex((x) => x.id === id);

    const customForm = customFormBuild.slice(0, pIndex + 1);
    const branch = [...customForm];

    branchFormBuilder.forEach((value, index) => {
      if (branchNumber === "" || branchNumber === index || branchNumber === "next") {
        if (selectedIndex <= index) {
          if (id !== value.id) {
            branchNumber = checkBranch(value, index);

            if (value.options?.length) {
              value.options.forEach((opt) => {
                if (branchNumber === "" && opt.goto != null) {
                  branchNumber = index;
                }
              });
            }

            branch.push(value);
          } else {
            branchNumber = branchOptionNum;
          }
        }
      }
    });

    setcustomFormBuilder(branch);
    // seteditformBranch(true);
  };

  const checkBranch = (value) => {
    const goto = value?.goto;
    if (goto == null || goto === "") return "";
    if (goto === "eof" || goto === "next") {
      return goto;
    }
    return Number(goto) - 1;
  };

  const questionTypeInput = (data, index, optionData) => {
    let type = {
      singleselect: (
        <CharacteristicCustomFormSingleSelect
          data={data}
          index={index}
          optionData={optionData}
          getForm={getForm}
          showViewForm={showViewForm}
          register={register}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          singleSelectVal={setgetForm}
          optionLevelbranching={optionLevelbranching}
          customFormBuilder={customFormBuilder}
          checkBranch={checkBranch}
        />
      ),
      multiselect: (
        <CharacteristicCustomFormMultiSelect
          data={data}
          index={index}
          optionData={optionData}
          getForm={getForm}
          showViewForm={showViewForm}
          register={register}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          addItemMultiselect={SelectedVal}
          removeItemMultiSelect={SelectedVal}
          optionLevelbranching={optionLevelbranching}
          customFormBuilder={customFormBuilder}
          checkBranch={checkBranch}
          setFormChangesConfirm={setFormChangesConfirm}
        />
      ),
      text: (
        <CharacteristicCustomFormText
          data={data}
          index={index}
          getTextBoxVal={SelectedVal}
          getForm={getForm}
          showViewForm={showViewForm}
          register={register}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      ),
    };
    return type[data.type];
  };

  const questionType = (data, index) => {
    let optionData = [];
    data.type !== "text" &&
      data.options.map((optionValue, optionIndex) => {
        return (optionData = [...optionData, { key: optionValue.key, value: optionValue.key === "other" ? "Others" : optionValue.value }]);
      });
    return questionTypeInput(data, index, optionData);
  };

  const isAnswered = (q) => {
    const hasValidOptions = Array.isArray(q.options) && q.options.some((opt) => typeof opt === "string" && opt.trim() !== "");

    const hasValidValue = typeof q.value === "string" && q.value.trim() !== "";

    return hasValidOptions || hasValidValue;
  };

  const validateMandatorySections = (answers, sectionInfo) => {
    const errors = [];

    sectionInfo.forEach((section) => {
      if (!section.isMandatory) return;

      const sectionAnswers = answers.filter((ans) => section.questionsId.includes(ans.id));

      const hasAtLeastOneAnswer = sectionAnswers.some(isAnswered);

      if (!hasAtLeastOneAnswer) {
        errors.push({
          sectionName: section.name,
          message: constants.customForm.sectionTooltip,
        });
      }
    });

    return errors;
  };

  const onSubmit = () => {
    const saveFormData = formBuilder?.length > 0 ? getForm?.formdata?.filter((item) => formBuilder.some((f) => f.id === item.id)) : [];

    const sectionErrors = validateMandatorySections(saveFormData, sectionInfo);

    if (sectionErrors.length > 0) {
      setSectionError(sectionErrors);
      return;
    }
    setSectionError([]);

    if (showViewForm.formdata !== null && showViewForm.formdata !== undefined && showViewForm.formdata.length > 0) {
      payload["method"] = "PUT";
    } else {
      payload["method"] = "POST";
    }
    payload["data"] = { formdata: saveFormData };
    let queryParamList = { feature: "NE1 WMS", subFeature: "Characteristics", ne1Id: queryParam?.ne1Id, assessmentId: queryParam?.assessmentId };
    dispatch(updateViewFormAsyn(payload, queryParamList));
    setTimeout(() => {
      updateDone(index);
      selectedIndex(index + 1);
    }, 1500);
  };

  const handleCancel = () => {
    setClickCancel(true);
  };

  return (
    <>
      {closeWarning && (
        <div className="text-center">
          <CloseWarning message="All progress in this section will be lost. Are you sure want to cancel?" yesFn={handleYes} noFn={handleNo} />
        </div>
      )}
      {getUserRole?.role === "ExternalStandardUser" ? (
        <>
          <p className={"mt-1"}>Custom form is not selected for this wound</p>
        </>
      ) : Array.isArray(characteristicTabsData) &&
        characteristicTabsData[0]["category"] === "History/Cause" &&
        characteristicTabsData[0]["isCompleted"] === 0 ? (
        <>
          <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>
            {"Please select History/Cause before selecting"} {name}
          </div>
        </>
      ) : Array.isArray(characteristicTabsData) &&
        characteristicTabsData[1]["category"] === "Tissue Type" &&
        characteristicTabsData[1]["isCompleted"] === 0 ? (
        <>
          <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>
            {"Please select Tissue Type(s) before selecting"} {name}
          </div>
        </>
      ) : (
        <Form
          setFormChangesConfirm={setFormChangesConfirm}
          formChanges={true}
          className={`pl-2 ${styles.patient_content} submit`}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-sm-12">
            {sections.map((section, sectionIndex) => {
              const error = sectionError.find((e) => e.sectionName === section.name);

              return (
                <div key={sectionIndex} className={styles.section}>
                  <div className={styles.sectionHeader}>
                    <span className={styles.sectionTitle}>{section.name} {section?.isMandatory === 1 ? <span className={styles.astrick}>&#42;</span> : ""}</span>
                    {section?.isMandatory === 1 && <Tooltip placement="right" className={styles.form_tooltip} content={constants.customForm.sectionTooltip}>
                      <img src={infoIcon} alt="info" />
                    </Tooltip>}
                  </div>

                  {error && <p className={styles.sectionError}>{error.message}</p>}

                  {section.questions.map((value, index) => (
                    <div key={value.id}>{value && questionType(value, index)}</div>
                  ))}
                </div>
              );
            })}
            <div className={styles.section}>
              {unSectioned.map((value, index) => (
                <div key={value.id}>{value && questionType(value, index)}</div>
              ))}
            </div>
            {customFormBuilder?.length > 0 ? (
              hideIt &&
              signedLockedAccess(assessmentDetails?.assessmentStage) && (
                <div className="text-center pb-4">
                  <br />
                  {isCompleted === 0 ? (
                    <Button classes={{ className: `btn pl-1 mr-4 ${styles.btn_primary}` }} type="submit" id={SUBMIT_ID}>
                      {"Next"}
                    </Button>
                  ) : (
                    <>
                      {/* Save Button */}
                      <Button classes={{ className: `btn pl-1 mr-4 ${styles.btn_primary}` }} type="submit" id={SUBMIT_ID}>
                        {SAVE_BTN}
                      </Button>
                      {/* Cancel button  */}
                      <Button
                        type={"button"}
                        classes={{ className: `btn ml-2 ${styles.btn_scondary} handlecancel` }}
                        id={CANCEL_ID}
                        onClick={() => {
                          handleCancel();
                        }}
                      >
                        {CANCEL_BTN}
                      </Button>
                    </>
                  )}
                </div>
              )
            ) : (
              <h4 className="text-center">No form</h4>
            )}
          </div>
        </Form>
      )}
    </>
  );
};
